import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import 'element-ui/lib/theme-chalk/index.css'
import "./global-components";
import "./libs";
import './assets/css/reset.css'
import './assets/css/asset.scss'
import "./assets/sass/app.scss";

import * as custom from './filters/filters'
Object.keys(custom).forEach(key => {
  Vue.filter(key, custom[key])
})

// Midone Theme

Vue.config.productionTip = false;

const vm=new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
import {getCookie} from "./assets/js/tools";
import './plugins/element.js'

router.beforeEach((to, from, next) => {
  if (to.path === '/login'||to.path === '/forget') {
    next()
  } else {
    if (getCookie('louguanjia_app_ticket')) {
      vm.$store.dispatch('getAccountProfile')
      if(to.meta.show){
        next()
      }else{
        // next('/404')
      }
    } else {
      next('/login')
    }
  }
})
